// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.result-modal {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 30px;
  background-color: #FFFFFF;
  padding-block: 66px 44px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.result-title {
  font-size: 41px;
  font-weight: 800;
  line-height: 56px;
  text-align: center;
}
.result-content {
  flex: 1;
  position: relative;
}
.result-content-image {
  width: 216px;
  height: 174px;
  margin: 78px auto 24px;
}
.result-content-amount {
  font-size: 48px;
  font-weight: 800;
  line-height: 64px;
  text-align: center;
  margin-bottom: 126px;
  white-space: nowrap;
}
.result-desc {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #000000;
}
.result-desc img {
  margin-top: 4px;
  width: 20px;
  height: 20px;
}
@media screen and (max-width: 452px) {
  .result-modal {
    padding-block: 106px 26px;
  }
  .result-title {
    font-size: 32px;
    line-height: 42px;
  }
  .result-content-amount {
    font-size: 32px;
    line-height: 38px;
  }
  .result-desc {
    font-size: 16px;
    line-height: 20px;
  }
  .result-desc img {
    margin-right: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/cashier/ResultModal/style.less"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AADJ;AAIE;EACE,OAAA;EACA,kBAAA;AAFJ;AAII;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAFN;AAKI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AAHN;AAQE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AANJ;AAFE;EAWI,eAAA;EACA,WAAA;EACA,YAAA;AANN;AAWA;EAEI;IACE,yBAAA;EAVJ;EAaE;IACE,eAAA;IACA,iBAAA;EAXJ;EAeI;IACE,eAAA;IACA,iBAAA;EAbN;EAiBE;IACE,eAAA;IACA,iBAAA;EAfJ;EAaE;IAKI,iBAAA;EAfN;AACF","sourcesContent":[".result {\n  &-modal {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 30px;\n    background-color: #FFFFFF;\n    padding-block: 66px 44px;\n    z-index: 9999;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  &-title {\n    font-size: 41px;\n    font-weight: 800;\n    line-height: 56px;\n    text-align: center;\n  }\n\n  &-content {\n    flex: 1;\n    position: relative;\n    \n    &-image {\n      width: 216px;\n      height: 174px;\n      margin: 78px auto 24px;\n    }\n    \n    &-amount {\n      font-size: 48px;\n      font-weight: 800;\n      line-height: 64px;\n      text-align: center;\n      margin-bottom: 126px;\n      white-space: nowrap;\n    }\n  }\n  \n  \n  &-desc {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 24px;\n    color: #000000;\n  \n    img {\n      margin-top: 4px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n@media screen and (max-width: 452px) {\n  .result{\n    &-modal {\n      padding-block: 106px 26px;\n    }\n\n    &-title {\n      font-size: 32px;\n      line-height: 42px;\n    }\n\n    &-content {\n      &-amount {\n        font-size: 32px;\n        line-height: 38px;\n      }\n    }\n\n    &-desc {\n      font-size: 16px;\n      line-height: 20px;\n\n      img {\n        margin-right: 8px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
